import { UdViewModel } from '../../../udView/udview';

export interface LayerDescriptor {
    id: string;
    label: string;
    get: (v: UdViewModel) => boolean;
    toggle: (v: UdViewModel) => void;
}

export const layerDescriptors: LayerDescriptor[] = [
    { id: 'aircraft', label: 'Aircraft', get: (v) => v.plane.settings.show, toggle: (v) => (v.plane.settings.show = !v.plane.settings.show) },
    { id: 'weather', label: 'Weather', get: (v) => v.weather.show, toggle: (v) => (v.weather.show = !v.weather.show) },
    { id: 'airport', label: 'Airport', get: (v) => v.staticData.airport.show, toggle: (v) => (v.staticData.airport.show = !v.staticData.airport.show) },
    { id: 'airspace', label: 'Airspace', get: (v) => v.staticData.airspace.show, toggle: (v) => (v.staticData.airspace.show = !v.staticData.airspace.show) },
    { id: 'airways', label: 'Airways', get: (v) => v.staticData.airway.show, toggle: (v) => (v.staticData.airway.show = !v.staticData.airway.show) },
    {
        id: 'drawingObjects',
        label: 'Drawing objects',
        get: (v) => v.staticData.drawingObjects.show,
        toggle: (v) => (v.staticData.drawingObjects.show = !v.staticData.drawingObjects.show)
    },
    { id: 'fixes', label: 'Fixes', get: (v) => v.staticData.fixes.show, toggle: (v) => (v.staticData.fixes.show = !v.staticData.fixes.show) },
    {
        id: 'serviceStations',
        label: 'Flight service stations',
        get: (v) => v.staticData.flightServiceStation.show,
        toggle: (v) => (v.staticData.flightServiceStation.show = !v.staticData.flightServiceStation.show)
    },
    { id: 'holding', label: 'Holding patterns', get: (v) => v.staticData.holding.show, toggle: (v) => (v.staticData.holding.show = !v.staticData.holding.show) },
    { id: 'latLon', label: 'Lat/Lon graticule', get: (v) => v.staticData.latLon.show, toggle: (v) => (v.staticData.latLon.show = !v.staticData.latLon.show) },
    { id: 'gridMora', label: 'Grid MORA', get: (v) => v.staticData.gridMora.show, toggle: (v) => (v.staticData.gridMora.show = !v.staticData.gridMora.show) },
    { id: 'navaids', label: 'Navaids', get: (v) => v.staticData.navaids.show, toggle: (v) => (v.staticData.navaids.show = !v.staticData.navaids.show) },
    {
        id: 'overwaterAreas',
        label: 'Overwater areas',
        get: (v) => v.staticData.overwaterAreas.show,
        toggle: (v) => (v.staticData.overwaterAreas.show = !v.staticData.overwaterAreas.show)
    },
    { id: 'sids', label: 'SIDs', get: (v) => v.staticData.sids.show, toggle: (v) => (v.staticData.sids.show = !v.staticData.sids.show) },
    { id: 'stars', label: 'STARs', get: (v) => v.staticData.stars.show, toggle: (v) => (v.staticData.stars.show = !v.staticData.stars.show) },
    { id: 'sua', label: 'Special Use Airspace (SUA)', get: (v) => v.staticData.sua.show, toggle: (v) => (v.staticData.sua.show = !v.staticData.sua.show) },
    { id: 'timeZones', label: 'Time zones', get: (v) => v.staticData.timeZone.show, toggle: (v) => (v.staticData.timeZone.show = !v.staticData.timeZone.show) },
    {
        id: 'weatherStations',
        label: 'Weather stations',
        get: (v) => v.staticData.weatherStation.show,
        toggle: (v) => (v.staticData.weatherStation.show = !v.staticData.weatherStation.show)
    },
    {
        id: 'customGeojson',
        label: 'Custom GeoJSON',
        get: (v) => v.staticData.customGeojson.show,
        toggle: (v) => (v.staticData.customGeojson.show = !v.staticData.customGeojson.show)
    }
];

